<template>
    <div v-if="visible" class="ah-alert-overlay">
        <div class="ah-alert-box">
            <!-- 自定义内容 -->
            <div class="ah-alert-content">
                {{ content }}
            </div>

            <!-- 动态按钮区域 -->
            <div class="ah-alert-buttons">
                <button v-for="(button, index) in buttons" :key="index" @click="handleButtonClick(button)"
                    :class="['ah-alert-button', button.className]" :style="button.style">
                    {{ button.text }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "AhAlert",
    data() {
        return {
            visible: false,
            content: "",
            buttons: [],
            resolvePromise: null,
            rejectPromise: null,
        };
    },
    methods: {
        // 显示弹窗
        show(options = {}) {
            this.content = options.content || "您触发了提示窗";
            this.buttons = options.buttons || [
                {
                    text: "确认",
                    style: { backgroundColor: "#0089ff" },
                    result: true
                },
                {
                    text: "取消",
                    style: { backgroundColor: "#343434" },
                    result: false
                }
            ];
            this.visible = true;

            // 返回一个 Promise，用于处理用户点击按钮
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            });
        },

        // 按钮点击事件处理
        handleButtonClick(button) {
            this.visible = false;

            if (typeof button.onClick === "function") {
                // 如果按钮有 onClick 回调，则执行它
                button.onClick(this.resolvePromise, this.rejectPromise);
            }

            // 根据 result 的值触发 .then 或 .catch
            if (button.result === true && this.resolvePromise) {
                this.resolvePromise(button.result);
            } else if (button.result === false && this.rejectPromise) {
                this.rejectPromise(button.result);
            }
        },
    },
};
</script>
<style scoped>
/* 背景遮罩 */
.ah-alert-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #00000070;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* 弹窗容器 */
.ah-alert-box {
    background-color: #1a1a1d;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px #0000003a;
    width: 300px;
    text-align: center;
    color: white;
}

/* 弹窗内容 */
.ah-alert-content {
    margin-bottom: 20px;
    font-size: 14px;
}

/* 按钮区域 */
.ah-alert-buttons {
    display: flex;
    justify-content: right;
}

/* 按钮通用样式 */
.ah-alert-buttons button {
    padding: 4px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: white;
    outline: none;
    margin-left: 10px;
}
</style>